module.exports = __webpack_public_path__ + "static/media/autohold.7a612c68.svg";